import { render } from "./IndexHeroCarousel.vue?vue&type=template&id=6f72cd1a"
import script from "./IndexHeroCarousel.vue?vue&type=script&lang=js"
export * from "./IndexHeroCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__